import { render, staticRenderFns } from "./myBidding.vue?vue&type=template&id=65855b53&scoped=true&"
import script from "./myBidding.vue?vue&type=script&lang=js&"
export * from "./myBidding.vue?vue&type=script&lang=js&"
import style0 from "./myBidding.vue?vue&type=style&index=0&id=65855b53&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65855b53",
  null
  
)

export default component.exports